$(document).ready(function() {

    var tabTitles = document.querySelectorAll('.tabs__title'),
        tabPanels = document.querySelectorAll('.tabs__panel'),
        tabMobileTitles = document.querySelectorAll('.tabs__mobile-heading'),
        firstTabTitle = document.querySelector('.tabs__title:first-of-type'),
        firstTabPanel = document.querySelector('.tabs__panel:first-of-type');

    function removeClassFromElement(targetElements, className) {
        document.querySelectorAll(targetElements).forEach(function(element) {
            element.classList.remove(className);
        });
    }

    function removeHeightFromElement(targetElements) {
        document.querySelectorAll(`${targetElements}`).forEach(function(element) {
            element.style.maxHeight = '0';
        });
    }

    let tooltip = $(".product-tooltip");
    let offsetX = 15, offsetY = 10;
    let hideTimeout;

    $(".choose-product-colour__item-swatch").hover(function(event){
        clearTimeout(hideTimeout); // Stop previous hide delay
        let colorName = $(this).parent().data("colourname");

        tooltip.text(colorName)
            .css({ top: event.pageY - offsetY, left: event.pageX + offsetX })
            .stop(true, true) // Stop any fade effects in progress
            .fadeIn(200);
    }, function(){
        hideTimeout = setTimeout(function(){
            tooltip.fadeOut(200);
        }, 300); // Slight delay to prevent flickering
    });

    $(document).mousemove(function(event){
        tooltip.css({ top: event.pageY - offsetY, left: event.pageX + offsetX });
    });

    if(document.querySelector('.tabs')) {

        tabTitles.forEach(function(title)  {
            title.addEventListener('click', function(e) {
                e.preventDefault();

                tabTitles.forEach(function(tabTitle) {
                    tabTitle.classList.remove('tabs__title--active');
                });

                tabPanels.forEach(function(panel) {
                    panel.classList.remove('tabs__panel--active');
                });

                let titleTargetPanel = title.getAttribute('data-title'),
                    targetPanel = document.querySelector(`.tabs__panel[data-panel=${titleTargetPanel}]`);

                title.classList.add('tabs__title--active');

                targetPanel.classList.add('tabs__panel--active');
            });
        });

        tabMobileTitles.forEach(function(mobileTitle) {
            mobileTitle.addEventListener('click', function(event){
                if(event.target.parentElement.classList.contains('tabs__panel--active')) {
                    event.target.parentElement.classList.remove('tabs__panel--active');
                    event.target.nextElementSibling.style.maxHeight = '0';
                } else {
                    removeClassFromElement('.tabs__panel', 'tabs__panel--active');
                    removeHeightFromElement('.tabs__inner');

                    event.target.parentElement.classList.add('tabs__panel--active');
                    event.target.nextElementSibling.style.maxHeight = '100%';
                }
            });
        });
    }

    //Wishlist
    $('.listing__wishlist a, .detail__wishlist a, .listing__wishlist a, .top-sellers__productblock__overlay__star, .product-card__sticker--wishlist').click(function(event) {
        event.preventDefault();

        var isProductCard = $(this).hasClass('product-card__sticker--wishlist');

        if(isProductCard) {
            var $this = $(this);
        } else {
            var $this = $(this).parent();
        }

        // For product cards, check for product-card__wishlist--active; for others, check for added
        var isInWishlist = isProductCard ? $this.hasClass('product-card__wishlist--active') : $this.hasClass('added');

        if(isInWishlist) {
            //Has the class, remove the product.
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/product/remove-from-wishlist.php',
                data: {
                    product: $this.data('product'),
                },
                success: function(response) {
                    response = JSON.parse(response);

                    setTimeout(function(){
                        $('.render-session-wishlist').load($(document.body).data('base') +'/ajax/product/render-session-wishlist.php');
                    }, 1500);
                    setTimeout(function(){
                      $('.render-session-wishlist-options').load($(document.body).data('base') +'/ajax/product/render-session-wishlist-options.php');
                    }, 1500);
                    swal({
                        title: '', 
                        text: response.message, 
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    });

                    // Check if this is in the account wishlist area
                    var $productCard = $this.closest('.product-card');
                    var isInAccountWishlist = $productCard.length > 0 && $productCard.closest('.account__wishlist').length > 0;

                    if (isInAccountWishlist && $productCard.length > 0) {
                        // Hide the product card in account area
                        $productCard.fadeOut(function() {
                            $(this).remove();
                        });
                    } else {
                        // Normal removal behavior for other areas
                        $this.removeClass('added');

                        if (isProductCard) {
                            $this.removeClass('product-card__wishlist--active');
                        }

                        if ( $this.hasClass('detail__wishlist') ) {
                            $this.find('a').text('Save this item');
                        }
                    }
                }
            });
        } else {
            //Doesn't have the class, add the product.
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/product/save-to-wishlist.php',
                data: {
                    product: $this.data('product'),
                },
                success: function(response) {
                    response = JSON.parse(response);

                    if(response.status == 'error') {
                        swal({
                            title: '',
                            text: response.message,
                            type: response.status,
                            showCancelButton: true,
                            cancelButtonText: 'Cancel',
                            confirmButtonText: 'Login',
                            closeOnConfirm: true,
                            closeOnCancel: true,
                            confirmButtonColor: "#f15a24"
                        }, function (isConfirm) {
                            if (isConfirm) {
                                window.location.href = response.login_url;
                            }
                        });
                    } else {
                        setTimeout(function(){
                            $('.render-session-wishlist').load($(document.body).data('base') +'/ajax/product/render-session-wishlist.php');
                        }, 1500);
                        setTimeout(function(){
                          $('.render-session-wishlist-options').load($(document.body).data('base') +'/ajax/product/render-session-wishlist-options.php');
                        }, 1500);
                        swal({
                            title: '',
                            text: response.message,
                            type: response.status,
                            confirmButtonColor: "#f15a24"
                        });
                    }

                    $this.addClass('added');


                    if (isProductCard) {
                        $this.addClass('product-card__wishlist--active');
                    }


                    if ( $this.hasClass('detail__wishlist') ) {
                        $this.find('a').text('Unsave this item');
                    }
                },
                error: function() {
                    console.log('Ajax request not received');
                }
            });
        }
    });

    //Remove all from session
    $('.wishlist__remove-all').click(function(event) {
        event.preventDefault();
        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/product/remove-all-wishlist.php',
            success: function(response) {
                response = JSON.parse(response);

                $(this).parents('.wishlist__list').fadeOut();
                setTimeout(function(){
                    $('.render-session-wishlist').load($(document.body).data('base') +'/ajax/product/render-session-wishlist.php');
                }, 1500);
                setTimeout(function(){
                  $('.render-session-wishlist-options').load($(document.body).data('base') +'/ajax/product/render-session-wishlist-options.php');
                }, 1500);
                swal({
                    title: '', 
                    text: response.message, 
                    type: response.status,
                    confirmButtonColor: "#f15a24"
                });
            }
        });
    });

    //email wishlist
    $('.email-wishlist').on('click',function(){
        var wishlist_email = $('.wishlist_email_address').val();

        if(wishlist_email != '') {
          $.ajax({
            type: "POST",
            url: $(document.body).data('base') + '/ajax/product/email-wishlist.php',
            data: {
              email: wishlist_email
            },
            success: function (response) {
              var $response = JSON.parse(response);
              if ('error' == $response.status) {
                swal({
                    title: 'Whoops!', 
                    text: $response.message, 
                    type: $response.status,
                    confirmButtonColor: "#f15a24"
                });
              } else {
                swal({
                    title: 'Success!', 
                    text: $response.message, 
                    type: $response.status,
                    confirmButtonColor: "#f15a24"
                });
              }
            }
          });
        }

    });

    //Change order of products based on sort options
    $('select[name="order_products"]').on('change', function() {
        var $location = updateQueryStringParameter(window.location.href, 'sort_by', $(this).val());

        window.location.href = $location;
    });
    //Change number of products shown per page
    $('select[name="view_per_page"]').on('change', function() {
        var $this = $(this);

        var $location = updateQueryStringParameter(window.location.href, 'per_page', $this.val());

        window.location.href = $location;
    });
    //Add/remove to current selection
    $('.filter__option').find('.form__checkbox').change(function() {
        $(this).parents('.listing-filters-form').submit();
    });

    $('.filter__color-button').click(function() {
        var check = $(this).children('.filter__dot').children('.form__checkbox');
        check.prop("checked", !check.prop("checked"));

        $(this).parents('.listing-filters-form').submit();
    });

    $('.cart-delete a.wishlist__remove').on('click', function() {
        $(this).parent().parent().remove();
    });
    $('.inc-vat, .ex-vat').on('click', function() {
        var id = $(this).data('id');
        var vat_select_form = $('form[name="vat_select_form"]');
        var select_input = vat_select_form.find('select#vat_select');

        select_input.val(id);
        vat_select_form.submit();
    });
});


//Individual remove product from wishlist
$(document).on("click", '.wishlist__remove', function(event) { 
    event.preventDefault();
    $.ajax({
        type: 'POST',
        url: $(document.body).data('base') + '/ajax/product/remove-from-wishlist.php',
        data: {
            product: $(this).data('productid'),
        },
        success: function(response) {
            response = JSON.parse(response);

            $(this).parents('.wishlist__list-item').fadeOut();
            setTimeout(function(){
                $('.render-session-wishlist').load($(document.body).data('base') +'/ajax/product/render-session-wishlist.php');
            }, 1500);
            setTimeout(function(){
              $('.render-session-wishlist-options').load($(document.body).data('base') +'/ajax/product/render-session-wishlist-options.php');
            }, 1500);
            swal({
                title: '', 
                text: response.message, 
                type: response.status,
                confirmButtonColor: "#f15a24"
            });
        }
    });
});

var spinner = $('.qty__input');

$(document).on("click", '.qty__button--up', function(e) {
    var value = parseInt($(this).parents('.qty--product').find('.qty__input').val(), 10);

    value = isNaN(value) ? 0 : value;
    value++;
    $(this).parents('.qty--product').find('.qty__input').val(value).trigger("change");
});

$(document).on("click", '.qty__button--down', function(e) {
    var value = parseInt($(this).parents('.qty--product').find('.qty__input').val(), 10);

    if(value !== 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        $(this).parents('.qty--product').find('.qty__input').val(value).trigger("change");
    }
});

$(document).on("click", '.qty__button', function(e) {
    var value = parseInt($(this).parents('.qty--product').find('.qty__input').val(), 10);

    if(value > 0) {
        $(this).parents('.qty--product').find('.qty__input').prev().css('opacity', 1);
        $(this).parents('.detail__product-size').addClass('detail__product-size--has-value');
    } else {
        $(this).parents('.qty--product').find('.qty__input').prev().css('opacity', 0.3);
        $(this).parents('.detail__product-size').removeClass('detail__product-size--has-value');
    }
});

$(document).on('change', '.qty__input', function(e) {
    let qty = 0
    $.map($(document).find('.qty__input'), function(ele, i) {
        const qtyVal = parseInt($(ele).val());
        if (0 !== qtyVal) {
            qty += qtyVal;
        }
    })

    $('.total-items span').html( qty );
});

$(document).on("click", '.oos-notify', function(e) {
    e.preventDefault();

    var $emailInput  = $(this).prev('input[name="oos_email"]');
    var $product = $(this).attr('data-product');
    var $option = $(this).attr('data-option');
    var $size = $(this).attr('data-size');

    if(!isEmail($emailInput.val())) {
        swal('', 'Please enter a valid email address (ensure valid format and no blank spaces).', 'error');
    } else {
        $.ajax({
            type: 'POST',
            url: $(document.body).data('base') + '/ajax/product/notify.php',
            data: 'email='+$emailInput.val()+'&product='+$product+'&option='+$option+'&size='+$size,
            success: function (response) {
                response = JSON.parse(response);
                $emailInput.val('');
                swal('', response.message, response.status);
            },
            error: function () {
                console.log('Ajax request not received');
            }
        });
    }

});

$(document).on("click", '.notify-in-stock', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parent('.inner').next().toggleClass('show');
});




$(document).ready(function () {
    function updatePriceBreakSelection() {
        let totalQuantity = parseInt($(".total-items span").text()) || 0;

        $(".product-detail__prices").each(function () {
            let bestMatch = null;

            $(this).find("input[type='radio']").each(function () {
                let breakpoint = parseInt($(this).closest("li").find(".product-detail__prices-item-quantity").text()) || 0;

                if (totalQuantity >= breakpoint) {
                    bestMatch = this; 
                }
            });

            if (bestMatch) {
                bestMatch.checked = true;
            }
        });
    }
    $(document).on("change", ".qty__input", function () {
        updatePriceBreakSelection();
    });
    updatePriceBreakSelection();
});
